import axios from "../axios-auth";

export const counterService = {
  getCountersByShopId,
  getCounterList,
  saveCounter,
  getCounterDetail
};

function getCounterDetail(id) {
  return axios.get("auth/counter/" + id);
}

function getCountersByShopId(id) {
  return axios.get("auth/counters-by-shop-id/" + id);
}
function getCounterList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  return axios.get("/auth/all-counter", { params });
}
function saveCounter(counter) {
  if (!counter.id) {
    // new counter
    return axios.post("/auth/counter", counter);
  } else {
    // edit
    return axios.put("/auth/counter", counter);
  }
}